const TOKENS = Object.freeze({
  primary: '--app-color-primary',
  primaryHover: '--app-color-primary-hover',
  primarySoft: '--app-color-primary-soft',
  canvas: '--app-color-canvas',
  surface: '--app-color-surface',
  border: '--app-color-border',
  text: '--app-color-text',
  textSecondary: '--app-color-text-secondary',
  textMuted: '--app-color-text-muted',
  success: '--app-color-success',
  successHover: '--app-color-success-hover',
  warning: '--app-color-warning',
  warningHover: '--app-color-warning-hover',
  danger: '--app-color-danger',
  dangerHover: '--app-color-danger-hover',
})

const getColor = (token, fallback = '') => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return fallback
  }

  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(token)
    .trim() || fallback
}

const theme = {
  // Compatibilidad para gráficos y configuraciones que requieren un valor
  // hexadecimal antes de que exista el DOM. Debe reflejar
  // $zyncro-primary-600 de assets/scss/_variables.scss.
  PRIMARY_COLOR: '#006F8C',
  TOKENS,
  getColor,
}

export default theme
